import { defineStore } from "pinia";
import { ref } from "vue";
export const useUploadStore = defineStore("upload", () => {
    const percentage = ref(0);
    const status = ref("");
    return { percentage, status };
});
